<template>
	<form method="post" enctype="multipart/form-data" ref="formProfile" @submit.prevent="updateProfile">
	    <input name="_token" type="hidden" :value="csrfToken">
	    <input type="hidden" name="avatar" v-model="profileData.avatar">
		<div class="row row-cards">
		    <div class="col-12 col-md-6 col-lg-6">
		        <div class="row row-cards">

					<div class="col-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Avatar</h3>
							</div>
							<div class="card-body">
	                            <div class="mb-3 ">                                  
	                                <img :src="avatar_url" style="width: 100px; height: 100px; border: 2px solid rgb(241, 241, 241); object-fit: cover;">
	                            </div>
	                            <div v-if="upload_progress" class="mb-3">
	                                <progress class="progress progress-sm" :value.prop="upload_percentage" max="100"/>
	                            </div>   
		                        <div class="mb-3">
		                            <div class="form-label">Browse Image</div>
		                            <input type="file" v-on:change="uploadAvatar" class="form-control" accept="image/png, image/jpeg, image/jpg">
		                            <input type="hidden" name="avatar" v-model="profileData.avatar">
		                            <small v-if="upload_message" class="form-hint">
		                                {{ message }}
		                            </small>
		                        </div>   
							</div>
						</div>						
					</div>


		            <div class="col-12">
		                <div class="card">
		                    <div class="card-header">
		                        <h3 class="card-title">Profile</h3>
		                    </div>
		                    <div class="card-body">
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="first_name">Email</label>
		                            <input type="text" v-model="profileData.email" class="form-control" readonly id="email">
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="first_name">First Name</label>
		                            <input type="text" v-model="profileData.first_name" class="form-control" id="first_name" name="first_name" placeholder="Enter First Name">
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="last_name">Last Name</label>
		                            <input type="text" v-model="profileData.last_name" class="form-control" id="last_name" name="last_name" placeholder="Enter Last Name">
		                        </div>
		                        <div class="form-group mb-3 ">
		                            <label class="form-label">Date of Birth</label>
		                            <div>
		                                <input type="text" id="datepicker" name="dob" v-model="profileData.dob" class="form-control" placeholder="Select a Date">
		                            </div>
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label">Gender</label>
		                            <div>
		                                <label class="form-check form-check-inline">
		                                    <input class="form-check-input" v-model="profileData.gender" name="gender" type="radio" value="male">
		                                    <span class="form-check-label" for="male">Male</span>
		                                </label>
		                                <label class="form-check form-check-inline">
		                                    <input class="form-check-input" v-model="profileData.gender" name="gender" type="radio" value="female">
		                                    <span class="form-check-label" for="female">Female</span>
		                                </label>
		                            </div>
		                        </div>
		                    </div>
		                    <div class="card-footer">
		                        <button type="submit" v-on:click="updateProfile" :disabled="validateForm" class="btn btn-primary">Update</button>
		                    </div>
		                </div>                      
		            </div>
		        </div>
		    </div>

		    <div class="col-12 col-md-6 col-lg-6">
		        <div class="row row-cards"> 	            
		            <div class="col-12">
		                <div class="card">
		                    <div class="card-header">
		                        <h3 class="card-title">Contact</h3>
		                    </div>
		                    <div class="card-body">
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="address_line_1">Address Line 1</label>
		                            <input type="text" v-model="profileData.address_line_1" class="form-control" id="address_line_1" name="address_line_1" placeholder="Enter Address Line 1">
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="address_line_2">Address Line 2</label>
		                            <input type="text" v-model="profileData.address_line_2" class="form-control" id="address_line_2" name="address_line_2" placeholder="Enter Address Line 2">
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="postcode">Postcode</label>
		                            <input type="text" v-model="profileData.postcode" maxlength="5" class="form-control" id="postcode" name="postcode" placeholder="Enter Postcode">
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="city">City</label>
		                            <input type="text" v-model="profileData.city" class="form-control" id="city" name="city" placeholder="Enter City">
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="state">State</label>
		                            <select class="form-select" name="state" v-model="profileData.state">
		                                <option value="">-- Select State --</option>
		                                <option v-for="(state, index) in states" :key="index" :value="state.name">{{ state.name }}</option> 
		                            </select> 
		                        </div>
		                        <div class="form-group mb-3">
		                            <label class="form-label" for="country">Country</label>
		                            <select class="form-select" name="country" v-model="profileData.country">
		                                <option value="">-- Select Country --</option>
		                                <option v-for="(country, index) in countries" :key="index" :value="country.name">{{ country.name }}</option> 
		                            </select>  
		                        </div>
		                    </div>
		                    <div class="card-footer">
		                        <button type="submit" v-on:click="updateProfile" :disabled="validateForm" class="btn btn-primary">Update</button>
		                    </div>
		                </div>                      
		            </div>

		            <div class="col-12">
		                <div class="card">
		                    <div class="card-header">
		                        <h3 class="card-title">Change Password</h3>
		                    </div>
		                    <div class="card-body">
		                        <div class="form-group mb-3 ">
		                            <label class="form-label">Current Password</label>
		                            <div>
		                                <input name="password" type="password" class="form-control" maxlength="20" placeholder="Enter Current Password">
		                            </div>
		                        </div>
		                        <div class="form-group mb-3 ">
		                            <label class="form-label">New Password</label>
		                            <div>
		                                <input name="new_password" type="password" class="form-control" maxlength="20" placeholder="Enter New Password">
		                            </div>
		                        </div>
		                        <div class="form-group mb-3 ">
		                            <label class="form-label">Confirm New Password</label>
		                            <div>
		                                <input name="new_password_confirmation" type="password" class="form-control" maxlength="20" placeholder="Enter Confirm New Password">
		                            </div>
		                        </div>                      
		                    </div>
		                    <div class="card-footer">
		                        <button type="submit" v-on:click="updateProfile" :disabled="validateForm" class="btn btn-primary">Update</button>
		                    </div>
		                </div>                      
		            </div> 

		        </div>
		    </div>
		</div>
	</form>
</template>

<script>
	import Litepicker from 'litepicker';
	export default {
        props: ['data'], 
        data() {
        	return {
        		csrfToken: "",
  				profileData: {
  					avatar: "",
  					first_name: "",
  					last_name: "",
  					dob: "",
  					gender: "",
  					address_line_1: "",
  					address_line_2: "",
  					postcode: "",
  					city: "",
  					state: "",
  					country: "",
  				},
  				avatar_url: window.location.origin + '/images/default.png',
  				hitBtnUpdate: false,
  				states: [],
  				countries: [],
  				upload_progress: false,
  				upload_percentage: 0,
  				message: "",
  				upload_message: false,
        	};
        },   
        mounted() {
        	this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
        	this.getProfileInfo();
        	this.getHelpers();
        	new Litepicker({
        		element: document.getElementById("datepicker"),
        	});
        }, 
        methods: {
        	getProfileInfo() {
        		axios.get('/api/ajax/profile/info').then(res => {
        			this.countries = res.data.countries;
        			this.states = res.data.states;
        		    this.profileData.email = res.data.user.email;
        		    this.profileData.first_name = res.data.user.first_name;
        		    this.profileData.last_name = res.data.user.last_name;
        		    this.profileData.dob = res.data.user.dob;
        		    this.profileData.gender = res.data.user.gender;
        		    this.profileData.address_line_1 = res.data.user.address_line_1;
        		    this.profileData.address_line_2 = res.data.user.address_line_2;
        		    this.profileData.postcode = res.data.user.postcode;
        		    this.profileData.city = res.data.user.city;
        		    this.profileData.state = res.data.user.state ?? "";
        		    this.profileData.country = res.data.user.country ?? "";
        		});
        	},
        	getHelpers() {
        		axios.get('/api/ajax/profile/helpers').then(res => {
        		    this.countries = res.data.countries;
        		    this.states = res.data.states;
        		});
        	},
    	   	uploadAvatar() {
	    		const file = event.target.files[0]; 
	    		if (file) {
	    		    this.upload_progress = true;
	    		    const form = new FormData();
	    		    form.append('file', file);
	    		    axios.post('/api/ajax/profile/upload-avatar',
	    		    form,
	    		    {
	    		        headers: {
	    		            'Content-Type': 'multipart/form-data'
	    		        },
	    		        onUploadProgress: function(progressEvent) {
	    		            this.upload_percentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
	    		        }.bind(this)
	    		    })
	    		    .then(res => {
	    		    	this.profileData.avatar = res.data.avatar;
	    		    	this.avatar_url = res.data.url;
			    	    this.upload_progress = false;
	    		    })
	    		    .catch(err => {  
	    		        console.log(err);                  
	    		    });                     
	    		}  
    	   	},
	    	updateProfile() {
	    		this.hitBtnUpdate = true;
	    		this.$refs.formProfile.submit();
	    	},
        },  
        computed: {
        	validateForm() {
        		if (this.hitBtnUpdate) {
        		    return true;
        		}    
        	},
        }     
	}
</script>